import clsx from "clsx";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { ICampanhaDesconto } from "../../types/CupomDesconto/ICampanhaDesconto";
const estiloCampanhasDeDescontosDisponiveis = require("./CampanhasDeDescontosDisponiveis.module.scss").default;

export type CampanhasDeDescontosDisponiveisProps = {
    campanhas: ICampanhaDesconto[];
    campanhasSelecionadas: ICampanhaDesconto[];
    onAbrirDetalhamento: (campanhaId: number) => void;
    onFecharComponente: () => void;
    onCampanhaSelecionada: (campanhas: ICampanhaDesconto[]) => void;
    onConfirmarCampanhasSelecionadas: () => void;
};

const CampanhasDeDescontosDisponiveis = (props: CampanhasDeDescontosDisponiveisProps) => {
    const [campanhasSelecionadas, setCampanhasSelecionadas] = useState<ICampanhaDesconto[]>(props.campanhas?.filter(c => props.campanhasSelecionadas?.map(cs => cs.Id).includes(c.Id)));
    const toggleCampanhaSelecionada = (campanha: ICampanhaDesconto) => {
      const permiteSelecionarCupomNaoAcumulativo = () => {
        return (R.filter((e) => !e.Acumulativo, campanhasSelecionadas).length > 0) || (!campanha.Acumulativo && campanhasSelecionadas.length > 0) ? false : true;
      }

      const permiteSelecionarCampanhaTipoFrete = () => {
        return campanha.Tipo == 3 &&  R.filter((e) => e.Tipo == 3, campanhasSelecionadas).length > 0 ? false : true;
      }

      
      if (campanhasSelecionadas?.filter(cs => cs.Id == campanha.Id).length>0) {
        setCampanhasSelecionadas(
          R.filter((e) => e.Id != campanha.Id, campanhasSelecionadas)
        );
      } else {
        if (permiteSelecionarCupomNaoAcumulativo() && permiteSelecionarCampanhaTipoFrete()) {
          setCampanhasSelecionadas(campanhasSelecionadas.concat(campanha));
        }
      }
      
    };

    const traduzTipoCampanha = (tipo: number) => {
      return tipo == 1 ? "Percentual" :
             tipo == 2 ? "Valor" : 
             tipo == 3 ? "Frete Grátis" :
             tipo;
    }
  
    useEffect(() => {
      props.onCampanhaSelecionada(campanhasSelecionadas);
    }, [campanhasSelecionadas]);

  return (
    <>  
     <div id="tabela-campanhas-desconto-disponiveis" className={estiloCampanhasDeDescontosDisponiveis.tabela}>
        <div>
          <div style={{flexBasis: "5%"}}>Sel.</div>
          <div style={{flexBasis: "20%"}}>Campanha</div>
          <div style={{flexBasis: "5%"}} title="Detalhe">Det.</div>
          <div>Validade <br /> Inicial</div>
          <div>Validade <br /> Final</div>
          <div>Valor Mínimo <br /> Venda</div>
          <div>Nº Máximo <br /> Utilização</div>
          <div>Quantidade<br /> Utilizada</div>
          <div>Tipo</div>
          <div>Valor</div>
        </div>
        {props.campanhas?.map((campanha) => {
            return (
            <div style={{ color: campanha.Acumulativo ? 'var(--mu-azul-marcador, blue)' : '', backgroundColor: campanha.AplicaOferta ? '#fef08a' : '' }} key={campanha.Id}>
              <div style={{flexBasis: "5%"}}><input type="checkbox" checked={campanhasSelecionadas?.filter(cs => cs.Id == campanha.Id).length > 0} onChange={() => {
                toggleCampanhaSelecionada(campanha);
              }}></input>
              </div>
              <div style={{flexBasis: "20%", placeContent: "start"}} >{campanha.Campanha}</div>
              <div style={{flexBasis: "5%"}}>
                <button 
                  onClick={ () => props.onAbrirDetalhamento(campanha.Id)}
                  title="Detalhe"
                >...</button></div>
              <div style={{placeContent: "start"}}>{globalMU.formatJsonDate(campanha.ValidadeInicial)}</div>
              <div style={{placeContent: "start"}}>{globalMU.formatJsonDate(campanha.ValidadeFinal)}</div>
              <div style={{placeContent: "end"}}>{globalMU.formatarValorNumerico(campanha.ValorMinimoVenda,2,false)}</div>
              <div style={{placeContent: "end"}}>{campanha.NumeroMaximoUtilizacao}</div>
              <div style={{placeContent: "end"}}>{campanha.QuantidadeUtilizada}</div>
              <div style={{placeContent: "start"}}>{traduzTipoCampanha(campanha.Tipo)}</div>
              <div style={{placeContent: "end"}}>{globalMU.formatarValorNumerico(campanha.Valor,2,false)}</div>
            </div>
          )})}
     </div>   

     <div className="_flex _justify-between">
       <div className="_flex _p-2">
         <div className="_flex"><div className={clsx(estiloCampanhasDeDescontosDisponiveis.acumulativoCor,"_mx-2", "_place-self-center")}></div><span>Acumulativo</span></div>
         <div className="_flex"><div className={clsx(estiloCampanhasDeDescontosDisponiveis.aplicaProdutosOfertaCor,"_mx-2", "_place-self-center")}></div><span>Aplica Sobre Produtos Em Oferta</span></div>
       </div>
       <div className="_flex _p-2 _gap-4">
          <button onClick={props.onConfirmarCampanhasSelecionadas} >Confirmar</button>
          <button onClick={props.onFecharComponente} >Fechar</button>

       </div>
     </div>
     {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};

export { CampanhasDeDescontosDisponiveis };